import { Alert, AlertTitle } from '@mui/material';

import { ReactNode } from 'react';

interface AlertWithTitleProps {
  alertTitle: string;
  children: ReactNode;
}

export const AlertWithTitle = (props: AlertWithTitleProps) => {
  return (
    <Alert severity="warning">
      <AlertTitle marginBottom={1}>{props.alertTitle}</AlertTitle>
      {props.children}
    </Alert>
  );
};
